import { render, staticRenderFns } from "./AddNetwork.vue?vue&type=template&id=2ec53b52&"
import script from "./AddNetwork.vue?vue&type=script&lang=js&"
export * from "./AddNetwork.vue?vue&type=script&lang=js&"
import style0 from "./AddNetwork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports